import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/views/NotFound';
// Account
import Login from '@/components/views/Login';
import Register from '@/components/views/Register';
import Account from '@/components/views/Account';
import AccountProfile from '@/components/views/AccountProfile';
// Admin
import Home from '@/components/views/Home';
import Dashboard from '@/components/views/Dashboard';
import Analytics from '@/components/views/Analytics';
import Config from '@/components/views/Config';
import Staff from '@/components/views/Staff';
import CreateAccount from '@/components/views/CreateAccount';
import Customers from '@/components/views/Customers';
import Customer from '@/components/views/Customer';
import Art from '@/components/views/Art';
import Artists from '@/components/views/Artists';
import Payouts from '@/components/views/Payouts';
import PayoutsEligible from '@/components/views/PayoutsEligible';
import PayoutsHistory from '@/components/views/PayoutsHistory';
import PayoutHistory from '@/components/views/PayoutHistory';
import PayoutEligible from '@/components/views/PayoutEligible';
import Shipments from '@/components/views/Shipments';
import Shipment from '@/components/views/Shipment';
import Orders from '@/components/views/Orders';
import Order from '@/components/views/Order';
import Return from '@/components/views/Return';
import Rentals from '@/components/views/Rentals';
import RentalCorporateNew from '@/components/views/RentalCorporateNew';
import Rental from '@/components/views/Rental';
import Piece from '@/components/views/Piece';
import Artist from '@/components/views/Artist';
import SubmitOk from '@/components/views/SubmitOk';
// Content
import Content from '@/components/views/Content';
import ContentFaq from '@/components/views/ContentFaq';
// Reports
import Reports from '@/components/views/Reports';
import ReportsRentals from '@/components/views/ReportsRentals';
import store from '@/store';

// Big load. So segmented.
// const Reports = () => import(/* webpackChunkName: "contact" */ '@/components/views/Reports');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { layout: 'layout-full' },
    },
    {
      path: '/account',
      component: Account,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'profile',
          name: 'AccountProfile',
          component: AccountProfile,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      // children: [
      //   {
      //     path: 'profile',
      //     name: 'AccountProfile',
      //     component: AccountProfile,
      //     meta: {
      //       layout: 'layout-service',
      //       authRequired: true,
      //     },
      //   },
      // ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'layout-app',
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        layout: 'layout-app',
      },
    },
    {
      path: '/configuration',
      name: 'Config',
      component: Config,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/reports',
      component: Reports,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'rentals',
          name: 'ReportsRentals',
          component: ReportsRentals,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/artists',
      name: 'Artists',
      component: Artists,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/artists/:artistId',
      name: 'Artist',
      component: Artist,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/art',
      name: 'Art',
      component: Art,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/art/:pieceId',
      name: 'Piece',
      component: Piece,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/shipments',
      name: 'Shipments',
      component: Shipments,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/shipment/:shipmentId',
      name: 'Shipment',
      component: Shipment,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/rentals',
      name: 'Rentals',
      component: Rentals,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/rental/:rentalId',
      name: 'Rental',
      component: Rental,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/rental/corporate/new',
      name: 'RentalCorporateNew',
      component: RentalCorporateNew,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/return/:customerOrderLineId',
      name: 'Return',
      component: Return,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/orders/:orderId',
      name: 'Order',
      component: Order,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/payouts',
      component: Payouts,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'eligible',
          name: 'PayoutsEligible',
          component: PayoutsEligible,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
        {
          path: 'history',
          name: 'PayoutsHistory',
          component: PayoutsHistory,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: '/payouts/history/:payoutId',
      name: 'PayoutHistory',
      component: PayoutHistory,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/payouts/eligible/:payoutId',
      name: 'PayoutEligible',
      component: PayoutEligible,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/submit-ok',
      name: 'SubmitOk',
      component: SubmitOk,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/customers',
      name: 'Customers',
      component: Customers,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/customers/:customerId',
      name: 'Customer',
      component: Customer,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
    {
      path: '/staff',
      name: 'Staff',
      component: Staff,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/create-account',
      name: 'CreateAccount',
      component: CreateAccount,
      meta: { layout: 'layout-service' },
    },
    {
      path: '/content',
      component: Content,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
      children: [
        {
          path: 'faq',
          name: 'ContentFaq',
          component: ContentFaq,
          meta: {
            layout: 'layout-service',
            authRequired: true,
          },
        },
      ],
    },
    // Example of dynamic route matching
    // {
    //   path: '/invoice/:orderId',
    //   name: 'Invoice',
    //   component: Invoice,
    //   meta: {
    //     layout: 'layout-service',
    //     authRequired: true,
    //   },
    // },
    {
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: {
        layout: 'layout-service',
        authRequired: true,
      },
    },
  ],
});

// eslint-disable-next-line consistent-return
router.beforeEach((to, from, next) => {
  // Set view layout
  store.commit('layout/setLayout', to.meta.layout);
  // Authenticate
  const authRequired = to.matched.some(record => record.meta.authRequired);
  const loggedIn = localStorage.getItem('user');
  // Route
  if (!loggedIn && authRequired) {
    // Save url user was going to, to continue there after login
    store.commit('account/setToUrl', to.path);
    return next('/login');
  }
  next();
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js